/* eslint-disable camelcase */
/* eslint-disable new-cap */
import Phaser from 'phaser';
import StarBase from '../objects/StarBase';
import Tweener from '../library/Tweener';
import StarField from '../objects/StarField';
import ABCyaPhaser, { Audio, Images } from '@abcya/abcya_phaser';
import DoorScene from './DoorScene';
import LevelSelect from './LevelSelect';
import AudioPlayer from '../library/AudioPlayer';
import gameData from '../gameData';
import Game from './Game';

export default class Win extends Phaser.Scene {
  static get KEY() {return 'Win';}

  create() {
    this.starField = new StarField(this);

    this.background = this.add.sprite(0, 0, Images.DEFAULT_ATLAS, 'bg3');
    this.background.setOrigin(.5);

    this.cont = this.add.container(this.scale.width * .5, this.scale.height * .5);

    this.niceWorkLogo = this.add.sprite(-50, -130, Images.LOCALIZATION_ATLAS, 'niceWork');

    this.cont.add([this.background, this.niceWorkLogo]);

    this.niceWorkLogo.setOrigin(.5);
    this.niceWorkLogo.setScale(5);
    this.niceWorkLogo.alpha = 0;
    this.cont.add(this.niceWorkLogo);

    this.niceWorkScale = 1;

    Tweener.To(this.niceWorkLogo, { scale: this.niceWorkScale }, 800, Phaser.Math.Easing.Back.Out);
    Tweener.To(this.niceWorkLogo, { alpha: 1 }, 800, Phaser.Math.Easing.None);

    this.time.addEvent({ delay: 500, callback: () => { this.addButtons(); } });
    this.time.addEvent({ delay: 1000, callback: () => { this.animateSpaceship(); } });

    AudioPlayer.PlaySound(this, AudioPlayer.sounds.YOU_ARE_AMAZING, false, 1, Audio.LOCALIZATION_AUDIO_SPRITE);
  }

  animateSpaceship() {
    const spaceShip_Conifig = {
      start_X: -400,
      start_Y: 600,
      end_X: 730,
      end_Y: 400,
      scale: 1
    };

    this.spaceship = this.add.sprite(spaceShip_Conifig.start_X, spaceShip_Conifig.start_Y, Images.DEFAULT_ATLAS, 'BonusShip');
    this.spaceship.setOrigin(.5);
    this.spaceship.setScale(spaceShip_Conifig.scale);

    Tweener.To(this.spaceship, { x: spaceShip_Conifig.end_X, y: spaceShip_Conifig.end_Y }, 1000, Phaser.Math.Easing.Circular.Out);

    AudioPlayer.PlaySound(this, AudioPlayer.sounds.CLICK);
  }

  addButtons() {
    const level = gameData.config.showOptions ? LevelSelect.KEY : Game.KEY;
    this.newGame_Button = this.createStar(this.scale.width / 2, this.scale.height - 190, ABCyaPhaser.Localization.instance.getLocalizedString('new_game_button'), -.08, level);
  }

  createStar(x, y, text, rotation, nextScene) {
    const starScale = .8;

    const starButton = new StarBase(this, x, y, text);
    starButton.rotationScale = rotation;
    starButton.starButton.once('pointerup', () => {this.nextScene(nextScene);});
    starButton.sprite.setScale(0);

    Tweener.To(starButton.sprite, { scale: starScale }, 800, Phaser.Math.Easing.Back.Out);

    return starButton;
  }

  nextScene(scene) {
    if (!gameData.config.showOptions) {
      gameData.indexStart = 0;
      gameData.curLevel = 1;
    }

    this.scene.get(DoorScene.KEY).changeScene(Win.KEY, scene);
  }

  loadGame(nextScene) {
    this.game.state.start(nextScene);
  }

  update() {
    if (this.newGame_Button) {
      this.newGame_Button.Update();
    }
  }
}